import React, { useState, useEffect, useRef } from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from "../../common/modal/index";
import api from '../../../services/axios';
import Swal from "sweetalert2";
import AppLoader from '../../common/AppLoader';

const UploadFile = ({ path, folderId, isOpen, closeCallback, successCallback }) => {
    const [files, setFiles] = useState([]);
    const [subBtnDisabled, setSubBtnDisabled] = useState(false);
    const fileRef = useRef();

    useEffect(() => {
        let val = [];
        setFiles([...val]);
        fileRef.current.value = null;
    }, [isOpen]);

    const handleFileChange = (event) => {
        for (var i = 0; i < event.target.files.length; i++) {
            handleFile(event.target.files[i]);
        }
    };

    const limitFileNameLength = () => {
        const val = files.map(e => e.name).join(', ');
        return val.length > 20 ? val.substring(0, 20) + "......" : val;
    };

    const handleDragOver = (event) => {
        event.preventDefault();
    };

    const handleDrop = (event) => {
        event.preventDefault();
        for (var i = 0; i < event.dataTransfer.files.length; i++) {
            handleFile(event.dataTransfer.files[i]);
        }
    };

    const handleFile = (e) => {
        var reader = new FileReader();
        let file = e;
        reader.onload = function (evt) {
            let prevFiles = files;
            prevFiles.push({
                file: evt.target.result.split('base64,')[1],
                name: file.name
            })
            setFiles([...prevFiles]);
        }
        reader.readAsDataURL(file);
    }

    const removeFile = (index) => {
        let prevFiles = files;
        prevFiles.splice(index, 1);
        setFiles([...prevFiles]);
    }

    const handleSubmit = async () => {
        if (!files || files.length === 0) {
            Swal.fire({
                position: "center",
                icon: "info",
                text: 'Please select at least one file',
                showConfirmButton: true,
                timer: 3000,
                timerProgressBar: true
            });
            return;
        }
        setSubBtnDisabled(true)
        try {
            const { data } = await api.post("/files", {
                files: files,
                folderGuid: folderId
            });
            if (data.statusCode === 200) {
                Swal.fire({
                    position: "center",
                    icon: "success",
                    text: 'Files uploaded successfully',
                    showConfirmButton: true,
                    timer: 3000,
                    timerProgressBar: true
                });
                if (successCallback)
                    successCallback(folderId);
                closeCallback();
            }
            else if (data.statusCode === 400) {
                Swal.fire({
                    text: 'The specified file already exists. Do you want to replace the file?',
                    icon: 'warning',
                    confirmButtonText: 'Replace',
                    showDenyButton: true,
                    denyButtonText: 'Cancel',
                    customClass: {
                        actions: 'my-actions',
                        cancelButton: 'order-2 right-gap',
                        confirmButton: 'order-1',
                        denyButton: 'order-3',
                    },
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        try {
                            const { data } = await api.post("files/ReplaceFile", {
                                files: files,
                                folderGuid: folderId
                            });
                            if (data.statusCode === 200) {
                                Swal.fire({
                                    position: "center",
                                    text: "File replaced successfully",
                                    confirmButtonText: "Ok",
                                    icon: 'success',
                                    timer: 3000,
                                    timerProgressBar: true
                                });
                                if (successCallback)
                                    successCallback(folderId);
                                closeCallback();
                            }
                        } catch (error) {
                            console.error('Error fetching data:', error);
                        }
                    }
                })
            }
        } catch (error) {
            console.log('Error fetching data:', error);
        }
        setSubBtnDisabled(false)
    }

    return (
        <Modal isLarge={true} isOpen={isOpen}>
            <ModalHeader>
                <h5 className="modal-title" id="exampleModalLabel">
                    <img src=" /Assets/file-icon.svg" /> Add File(s)
                </h5>
            </ModalHeader>
            <ModalBody>
                <div className="row g-3">
                    <div className="col-md-6">
                        <p className='pop-head'>Drag & Drop to Upload</p>
                        <div
                            className="drag-box"
                            onDragOver={handleDragOver}
                            onDrop={handleDrop}
                        >
                            <img src="/Assets/drag (2).svg" alt="Upload files" />
                        </div>
                        <p className='my-3 text-center'><strong>OR</strong></p>
                        <div className="upload-box">
                            <label htmlFor="myfile" className="custom-file-label">
                                {files && files.length > 0
                                    ? limitFileNameLength()
                                    : "Click to upload file(s)"}
                            </label>
                            <input
                                ref={fileRef}
                                type="file"
                                id='myfile'
                                name='myfile'
                                className="file-input"
                                onChange={handleFileChange}
                                multiple={true}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <p className='pop-head'>List of File(s)</p>
                        <div className='list-file-box' style={{ overflowY: 'auto' }}>
                            {files.map((d, index) => (
                                <div key={index} className="file-item">
                                    <span>{index + 1}) {d.name}</span>
                                    <button type='button' onClick={() => removeFile(index)} className='class="btn btn-sm btn-danger btn-xs'>X</button>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className='destination-box'>
                    <div className='dest-left'>
                        Destination Path
                    </div>
                    <div className='dest-right'>
                        {path}
                    </div>
                </div>
            </ModalBody>
            <ModalFooter>
                {
                    subBtnDisabled ? <AppLoader /> :
                        <><button
                            type="button"
                            className="btn btn-secondary"
                            onClick={closeCallback}
                        >
                            Cancel
                        </button>
                            <button disabled={subBtnDisabled} type="button" onClick={handleSubmit} className="btn btn-primary">
                                Upload
                            </button></>
                }
            </ModalFooter>
        </Modal>);
};
export default UploadFile;